import errorTracker from "error_tracker"

const errorReporter = {
  setErrorPayload: (payload) => {
    errorTracker.setErrorPayload(payload)
  },

  getErrorPayload: () => errorTracker.getErrorPayload(),

  sendErrorMsg: (messageOrError, payload = {}) => {
    errorTracker.sendErrorMsg(messageOrError, payload)
  },

  error: (messageOrError, payload = {}) => {
    errorTracker.sendErrorMsg(messageOrError, {...payload, level: "error"})
  },

  warn: (messageOrError, payload = {}) => {
    errorTracker.sendErrorMsg(messageOrError, {...payload, level: "warning"})
  }
}

export default errorReporter